

const Privacy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__container">
        <h1 className="privacy-policy__title">Privacy Policy</h1>

        <section className="privacy-policy__section">
          <h2>1. Introduction</h2>
          <p>
            We are committed to protecting your privacy. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your information when you visit our website, or engage with
            our services. By accessing or using our services, you agree to the terms of this Privacy Policy.
          </p>
        </section>

        <section className="privacy-policy__section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information when you use our services:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> This includes your name, email address, phone
              number, and any other information you provide us directly.
            </li>
            <li>
              <strong>Payment Information:</strong> If you make a purchase, we may collect your
              payment information, such as credit card details and billing address, through our
              secure payment processing partner.
            </li>
            <li>
              <strong>Usage Data:</strong> We automatically collect information about your
              interactions with our website, including your IP address, browser type, device
              information, pages visited, and the time and date of your visit.
            </li>
            <li>
              <strong>Cookies and Tracking Technologies:</strong> We use cookies and similar
              technologies to enhance your experience on our site and analyze usage patterns. You
              can manage cookie preferences through your browser settings.
            </li>
          </ul>
        </section>

        <section className="privacy-policy__section">
          <h2>3. How We Use Your Information</h2>
          <p>We may use the information we collect for various purposes, including:</p>
          <ul>
            <li>To provide, maintain, and improve our services.</li>
            <li>
              To process transactions and send you related information, including purchase
              confirmations and invoices.
            </li>
            <li>
              To communicate with you, including responding to your comments, questions, and
              requests.
            </li>
            <li>To send you promotional materials and newsletters, with your consent.</li>
            <li>
              To analyze usage patterns and improve the functionality and user experience of our
              website.
            </li>
            <li>To detect, prevent, and address technical issues or fraudulent activity.</li>
          </ul>
        </section>

        <section className="privacy-policy__section">
          <h2>4. Disclosure of Your Information</h2>
          <p>We may share your information in the following circumstances:</p>
          <ul>
            <li>
              <strong>With Service Providers:</strong> We may share your information with third-party
              vendors, service providers, contractors, or agents who perform services on our behalf,
              such as payment processing, data analysis, email delivery, and marketing assistance.
            </li>
            <li>
              <strong>Legal Compliance:</strong> We may disclose your information to comply with
              applicable laws, regulations, legal processes, or governmental requests, or to protect
              our rights, privacy, safety, or property, and/or that of our affiliates, you, or others.
            </li>
            <li>
              <strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or
              asset sale, your information may be transferred as part of that transaction.
            </li>
          </ul>
        </section>

        <section className="privacy-policy__section">
          <h2>5. Security of Your Information</h2>
          <p>
            We take reasonable steps to protect the information we collect from loss, theft, misuse,
            and unauthorized access, disclosure, alteration, and destruction. However, please be
            aware that no method of transmission over the Internet or method of electronic storage is
            100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section className="privacy-policy__section">
          <h2>6. Your Rights and Choices</h2>
          <p>You have certain rights regarding your personal information, including:</p>
          <ul>
            <li>
              <strong>Access and Update:</strong> You can access and update your personal
              information by contacting us directly.
            </li>
            <li>
              <strong>Opt-Out:</strong> You may opt out of receiving promotional communications from
              us by following the unsubscribe instructions included in those communications or by
              contacting us.
            </li>
            <li>
              <strong>Cookies:</strong> You can manage your cookie preferences through your browser
              settings. However, disabling cookies may limit your ability to use certain features of
              our website.
            </li>
          </ul>
        </section>

        <section className="privacy-policy__section">
          <h2>7. Third-Party Websites</h2>
          <p>
            Our website may contain links to third-party websites that are not operated by us. This
            Privacy Policy does not apply to those websites, and we encourage you to review the
            privacy policies of any third-party sites you visit.
          </p>
        </section>

        <section className="privacy-policy__section">
          <h2>8. Children’s Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 18. We do not knowingly
            collect personal information from children under 18. If we become aware that we have
            collected personal information from a child under 18, we will take steps to delete such
            information.
          </p>
        </section>

        <section className="privacy-policy__section">
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by
            posting the new Privacy Policy on this page and updating the “Effective Date” at the top.
            You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
